import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  id: PropTypes.string,
};

const MyMatchesIcon = ({
  color = '#B5BCBD',
  size = 17,
  id = 'my-matches-icon',
  ...props
}) => (
  <svg width={size} viewBox="0 0 22 23" {...props}>
    <defs>
      <path
        d="M2.106 14.903v4.902h4.768L6.875 22H1.421c-.75 0-1.363-.598-1.417-1.357L0 20.533v-5.63h2.106Zm19.894 0v5.63c0 .774-.58 1.407-1.315 1.463L20.58 22h-5.454v-2.194l4.749-.001v-4.902H22Zm-8.548-4.343c2.019.366 3.561 2.325 3.561 4.689 0 1.298-2.666 2.351-5.954 2.351-3.29 0-5.955-1.053-5.955-2.351 0-2.364 1.542-4.323 3.561-4.689.51.435 1.125.725 1.794.813l.183.02.249.009h.335l.249-.01a3.44 3.44 0 0 0 1.977-.832ZM11.06 3.52c1.877 0 3.402 1.479 3.402 3.295 0 1.817-1.525 3.745-3.402 3.745-1.877 0-3.403-1.928-3.403-3.745 0-1.817 1.526-3.295 3.403-3.295ZM6.875 0v2.2h-4.77v4.897H0v-5.63C0 .657.636 0 1.42 0h5.455Zm13.704 0c.75 0 1.363.598 1.417 1.357l.004.11v5.63h-2.126V2.2h-4.749V0h5.454Z"
        id={`${id}-a`}
      />
    </defs>
    <g transform="translate(.315)" fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        fill={color}
        mask={`url(#${id}-b)`}
        d="M-.876-.733h24.102v23.466H-.876z"
      />
    </g>
  </svg>
);

MyMatchesIcon.propTypes = propTypes;

export default MyMatchesIcon;
